import { all } from 'redux-saga/effects';

import ClientSaga from '../containers/client/sagas'

export default function* IndexSaga() {
  yield all([
    ClientSaga(),
  ]);
}
